import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import data from "./data.json";
import { PortfolioData } from "./types";
import "./App.css";

// Import Bootstrap CSS and JS
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

// Import your global components
import Footer from "./components/Footer";
import Navigation from "./components/Navigation";
import BackToTop from "./components/BackToTop";

// Import your page components
import HomePage from "./pages/HomePage";
import ProjectsPage from "./pages/ProjectsPage";

const App: React.FC = () => {
  const portfolioData: PortfolioData = data;

  return (
    <Router>
      {/* Navigation bar that appears on all pages */}
      <Navigation basics={portfolioData.basics} portfolioData={portfolioData} />

      <main>
        <Routes>
          <Route
            path="/"
            element={<HomePage portfolioData={portfolioData} />}
          />
          <Route
            path="/home"
            element={<HomePage portfolioData={portfolioData} />}
          />
          <Route
            path="/projects"
            element={<ProjectsPage projects={portfolioData.projects} />}
          />
          {/* Add more routes here for other specific pages if needed */}
        </Routes>
      </main>

      <Footer />
      <BackToTop />
    </Router>
  );
};

export default App;
